import React from 'react';
import { connect } from 'react-redux';
import StatisticsByRefererSegments from './StatisticsByRefererSegments';

const StatisticsByRefererSegmentsComponent = connect(
    function mapStateToProps(state) {
        return {
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
        };
    }
)(StatisticsByRefererSegments);

export default StatisticsByRefererSegmentsComponent;
